module.exports = __webpack_public_path__ + "static/img/104153.a2d632c9.png";